<div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0"  *ngIf="sessionData">
  <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
    <div class="uk-grid-small uk-flex-middle uk-grid">
      <div class="uk-width-expand uk-width-5-6">
        <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
          Sessions
        </h3>
      </div>
      <div class="info primary-color uk-width-1-6 k-text-right">
        <i
          class="k-icon k-i-info"
          uk-tooltip="Il s’agit du volume de sessions en fonction des filtres appliqués.</br>
             Le compteur de « Dates » de formation cumule le nombre de dates tandis que le compteur de « Jours » cumule le nombre de demi-journées. Ex : ½ journée le 1er juin et ½ journée le 2 juin compteront pour 2 dates de formation et 1 jour de formation.<br>
            Notez que le statut des sessions évoluant dans le temps, les données peuvent varier en fonction du moment de la consultation de l’indicateur.<br>
            Masquez/affichez cet indicateur sur l’extranet de l’intervenant à l’aide du switch situé en haut à droite de la tuile."
        ></i>
      </div>
    </div>
  </div>
  <div class="uk-card-body uk-padding-small">
      <p class="stats-sub-title margin-left-12">Nombre</p>
      <p class="margin-left-12">
        <span class="stats-number-before"> {{ sessionData.nbSession[0].coalesce || 0 }}</span>
      </p>
      <p class="stats-sub-title margin-left-12">Jours de fromation</p>
      <p class="margin-left-12">
          <span class="stats-number-before" *ngIf="sessionData.totalJour[0]">{{
            sessionData.totalJour[0].jour || 0
            }}</span>
        <span class="stats-number-before" *ngIf="!sessionData.totalJour[0]">
            Donnée indisponible
          </span>
      </p>
      <p class="stats-sub-title margin-left-12">Heures de formation</p>
      <p class="margin-left-12">
          <span class="stats-number-before" *ngIf="sessionData.totalHeure[0].heure">{{
            sessionData.totalHeure[0].heure.hours || 0
            }}</span>
        <span class="stats-number-before" *ngIf="!sessionData.totalHeure[0]">
            Donnée indisponible
          </span>
      </p>

  </div>
</div>
